import {useState} from 'react';

import {Box, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

import {getButtonColor, getButtonSx, getButtonText} from './utils';
import {secretShape} from '../../../proptypes-shapes';
import Button from '../../form/buttons/Button/Button';
import SingleSecretFoldersList from '../SingleSecretFoldersList/SingleSecretFoldersList';
import UpdateSecretForm from '../UpdateSecretForm/UpdateSecretForm';

const SingleSecret = ({secret}) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const isEditable = secret.is_editable;

  const toggleForm = () => {
    if (!isEditable) return;
    setIsFormOpen(prev => !prev);
  };

  const buttonText = getButtonText(isEditable, isFormOpen);
  const buttonColor = getButtonColor(isEditable, isFormOpen);
  const buttonVariant = isFormOpen ? 'outlined' : 'contained';
  const buttonSx = getButtonSx(isEditable);

  return (
    <Box width="100%">
      <Grid
        flexDirection={{
          xs: 'column',
          sm: 'row'
        }}
        gap={{
          xs: 2,
          md: 5
        }}
        container
        flexWrap={{xs: 'wrap', sm: 'nowrap'}}
      >
        <Grid item>
          <Typography fontWeight="bold" color="text.disabled">
            Nom du secret
          </Typography>
          <Typography fontSize={13}>{secret.secret_name}</Typography>
        </Grid>

        <Grid item>
          <Typography fontWeight="bold" color="text.disabled">
            Dossiers
          </Typography>
          <SingleSecretFoldersList folders={secret.folders} />
        </Grid>

        <Grid container gap={2} flex={1} item justifyContent="flex-end" alignItems="center" flexWrap="nowrap">
          <Button size="small" onClick={toggleForm} disabled={!isEditable} color={buttonColor} variant={buttonVariant} sx={buttonSx}>
            {buttonText}
          </Button>
        </Grid>
      </Grid>

      {isEditable && isFormOpen && (
        <UpdateSecretForm
          secret={secret}
          onClose={() => {
            setIsFormOpen(false);
          }}
        />
      )}
    </Box>
  );
};

SingleSecret.propTypes = {
  secret: secretShape.isRequired
};

export default SingleSecret;
